import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/** The access mode the API gave this tab's session ("ActivationPortal" before the company is live). */
export const ACCESS_MODE_KEY = 'accessMode';
export const ACTIVATION_PORTAL = 'ActivationPortal';

export function isActivationPortalSession(): boolean {
  return sessionStorage.getItem(ACCESS_MODE_KEY) === ACTIVATION_PORTAL;
}

/**
 * SA-14: a restricted pre-activation session never opens the platform console. SA-23: it does open the company dashboard (basic
 * data editable, the rest view-only, enforced by the API).
 */
export const notInActivationPortalGuard: CanActivateFn = () =>
  isActivationPortalSession() ? inject(Router).parseUrl('/activation') : true;

/** The activation page: only for a restricted session; anyone else goes to their own home or to sign-in. */
export const activationPortalOnlyGuard: CanActivateFn = () => {
  if (isActivationPortalSession()) return true;
  return inject(Router).parseUrl(sessionStorage.getItem('token') ? '/dashboard' : '/login');
};
